/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description shouldFiltersOmitRelCanonical
 */

import { isBedroomsSelected } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'

/**
 * cases checked:
 * - maxDays === 1 (/today in pathname)
 * - bedrooms specified in filters (/studios etc in pathname)
 *
 * @param filters
 */
export const shouldFiltersOmitRelCanonical = (filters: Filters) =>
  filters.maxDays === 1 || isBedroomsSelected(filters)
